import { CredentialsCard } from "@/features/account/components/change-details/credentials-card";
import { MfaCard } from "@/features/account/components/change-details/mfa-card";

function LoginDetails() {
    return (
        <div className="px-4 py-8">
            <div className="container mx-auto space-y-4">
                <h1 className="mb-4 text-2xl font-semibold">
                    Account Settings
                </h1>
                <CredentialsCard />
                <MfaCard />
            </div>
        </div>
    );
}

export default LoginDetails;
